import { Flex } from 'rebass';
import styled from 'styled-components';

export const ConflictItem = styled(Flex)`
  gap: 8px;
  border: 1px solid #eae9ec;
  border-radius: 8px;
  transition: all 0.5s;
  cursor: pointer;

  &:hover {
    border-color: black;
  }
`;
